export default __webpack_public_path__ + "static/media/settj.b74dc74b.jpg";